// extracted by mini-css-extract-plugin
export default {"tasks":"bN-z","task":"cN-z","svg":"dN-z","text":"eN-z"};